import { useAccount } from "components/hooks/accounts/useAccount";
import { useEnableNewNavigationButtons } from "components/hooks/feature-flags";
import { useBootstrap } from "components/store/source";

import { useAllowedActions } from "hooks/actions/useAllowedActions";
import { ActionType } from "types/graphql";

export const useUserActions = () => {
  const bootstrap = useBootstrap();
  const account = useAccount({ bootstrap });
  const canQa = account?.canQa;

  const allowedActions = account?.actions;

  const { getActionConfig } = useAllowedActions({ allowedActions });
  const hasPermissionEdit = getActionConfig(
    ActionType.AccountEdit,
  ).isActionAllowed;
  const hasPermissionView = getActionConfig(
    ActionType.AccountView,
  ).isActionAllowed;

  const canViewProfile = hasPermissionEdit && hasPermissionView;

  const enableNewNavigationButtons = useEnableNewNavigationButtons();

  const userActions = enableNewNavigationButtons
    ? canViewProfile
      ? ["my_profile", ...(canQa ? ["dev_tools"] : []), "log_out"]
      : [...(canQa ? ["dev_tools"] : [])]
    : ["my_stays", "edit_profile", ...(canQa ? ["dev_tools"] : []), "log_out"];

  return userActions;
};
